<template>
    <div class="absolute top-4 left-5">
        <img src="@/assets/icon/misc/hamburger-menu.svg" alt @click="openMenu()" />
    </div>

    <div
        class="fixed z-index-fixed top-0 left-0 overflow-hidden duration-500 ease-in-out transform-gpu"
        :class="SideMenuStore.state.active ? 'sidebar-open translate-x-0' : 'sidebar-close -translate-x-full'"
    >
        <div
            class="bg-black bg-opacity-70 w-screen h-screen fixed top-0 left-0"
            v-if="SideMenuStore.state.active"
            @click="closeMenu()"
        ></div>
        <div class="sidemenu-bg p-5 h-screen relative font-main-regular flex flex-col">
            <div class="absolute top-4 right-4">
                <img
                    class="ic-close"
                    @click="closeMenu()"
                    src="@/assets/icon/sidebar/close_white.svg"
                />
            </div>
            <div class="profile-info flex flex-row items-center mb-4">
                <div class="mr-3.5" v-if="profileImageUrl != null">
                    <div class="img-wrap border border-white bg-transparent rounded-full">
                        <img
                            class="w-full h-full border-2 border-transparent rounded-full"
                            :src="profileImageUrl"
                        />
                    </div>
                </div>
                <div class="mr-3.5" v-else>
                    <div
                        class="img-wrap border border-white bg-transparent rounded-full bg-gray-400"
                    ></div>
                </div>
                <div class="profileName text-white text-base uppercase pr-8 flex-auto">
                    <div class="line-clamp-1 break-all">{{ profileFirstName }}</div>
                    <div class="line-clamp-1 break-all">
                        {{ profileLastName }}
                    </div>
                </div>
            </div>
            <div class="group-menu border-t font-main-regular text-base text-white leading-normal">
                <div class="pt-5" @click="goToPage('/profile')">{{ lbl.sidemenu.service_info }}</div>
                <div
                    class="pt-5"
                    @click="goToPage('/promotion/special4you')"
                >{{ lbl.sidemenu.special_for_u }}</div>
                <div class="pt-5" @click="goToPage('/promotion/hot')">{{ lbl.sidemenu.hot_promo }}</div>
                <div
                    class="pt-5"
                    @click="goToPage('/card-privileges')"
                >{{ lbl.sidemenu.card_privileges }}</div>
                <div
                    class="pt-5"
                    @click="goToPage('/promotion/search')"
                >{{ lbl.sidemenu.search_promo }}</div>
                <div
                    class="py-5"
                    @click="goToPage('/apply-card')"
                >{{ lbl.sidemenu.apply_card }}</div>

                <!-- <div
                    class="py-5"
                    @click="goToPage('/platinum-service')"
                >{{ lbl.sidemenu.platinum_service }}</div> -->
            </div>
            <div
                class="group-menu-footer mt-auto border-t font-main-regular text-sm text-white leading-normal"
            >
                <div class="pt-5" @click="goToPage('/faq')">{{ lbl.sidemenu.faq }}</div>
                <div class="pt-5" @click="goToPage('/terms')">{{ lbl.sidemenu.term_cond }}</div>
                <div class="pt-5" @click="goToPage('/privacy')">{{ lbl.sidemenu.data_privacy }}</div>
                <div class="pt-5" @click="goToPage('/privacymenu')">{{ lbl.sidemenu.privacy }}</div>
                <div class="pt-5" @click="goToPage('/contact-us')">{{ lbl.sidemenu.contact_us }}</div>
                <div class="group-footer pt-5 flex flex-row">
                    <img src="@/assets/img/logo/buzzebees-logo-white.svg" />
                    <LangSwitcher :customClass="langSwitcherClass"></LangSwitcher>
                </div>
            </div>
        </div>
    </div>

    <ModalMaster :controller="modalController"></ModalMaster>

    <transition name="fade">
        <div class="modal-backdrop" v-if="SideMenuStore.state.active" @click="closeMenu()"></div>
    </transition>
</template>
<script>
//component
import LangSwitcher from "@/components/Layout/TopBar/component/LangSwitcher.vue";
//mixin
import LocaleMixin from "@/mixin/LocaleMixin.js";
import ModalMixin from '@/mixin/ModalMixin.js';
// import AuthPageMixin from "@/mixin/AuthPageMixin.js";
//helper
import Account from '@/helper/AccountHelper.js';
export default {
    name: "SideMenu",
    mixins: [LocaleMixin, ModalMixin],
    inject: ['SideMenuStore', 'AccountStore'],
    data: function () {
        return {
            pageActive: this.$route.name,
            langSwitcherClass: 'absolute bottom-6 right-5',
            formData: null,
            profileName: "Welcome <br />Guest",
            profileFirstName: "Welcome",
            profileLastName: "Guest",
            profileImageUrl: null,
            trackingScreenName: 'side_menu',
        };
    },
    components: {
        LangSwitcher
    },
    watch: {
        $route: function () {
            this.closeMenu();
        },

        'SideMenuStore.state.active': function () {
            let active = this.SideMenuStore.state.active;
            // console.log('side menu change', this.SideMenuStore.state.active);
            setTimeout(() => {
                if (active) {
                    document.body.classList.add('not-scroll');
                } else {
                    document.body.classList.remove('not-scroll');
                }
            }, 500);
        },
        'AccountStore.state.profile': function () {
            this.init()
        }
    },
    mounted: function () {
        this.init()
    },
    methods: {
        init: function () {
            let accountLine = Account.getCacheUser()
            // console.log(accountLine)
            if (accountLine != null && accountLine.line != null) {
                this.profileImageUrl = accountLine.line.pictureUrl;
                // this.profileName = Account.getCacheUser().line.displayName || null;
            }

            if (this.AccountStore.state.profile != null) {
                this.formData = this.AccountStore.state.profile;
                this.profileName = this.formData.name;
                this.profileFirstName = this.formData.firstName
                this.profileLastName = this.formData.lastName
            }
        },
        onSetupModalCompleted: function () {
            this.initialPdpaModal();
        },
        openMenu: function () {
            this.SideMenuStore.methods.open();
            this.tracking.screenName(this.trackingScreenName);
        },
        closeMenu: function () {
            this.SideMenuStore.methods.close();
        },
        goToPage: function (page) {
            if (!page) return;

            var currentPath = this.$route.path;
            if (page != currentPath) this.$router.push(page);
            this.setTracking(page)
        },
        openPdpaModal: function (type) {
            this.setTracking(type);
            let title = type == 'terms'
                ? this.lbl.sidemenu.term_cond
                : this.lbl.sidemenu.data_privacy;
            this.closeMenu();
            this.modalController.pdpaModal
                .clearModal()
                .setType(type)
                .setTitle(title)
                .show();
        },
        setTracking: function (page) {
            let trackCategory = '';
            let trackAction = '';
            switch (page) {
                case '/profile':
                    trackCategory = 'service_information';
                    trackAction = 'click_service_information';
                    break;
                case '/promotion/special4you':
                    trackCategory = 'special_for_you';
                    trackAction = 'click_special_for_you';
                    break;
                case '/promotion/hot':
                    trackCategory = 'hot_promotion';
                    trackAction = 'click_hot_promotion';
                    break;
                case '/promotion/search':
                    trackCategory = 'searching_promotion';
                    trackAction = 'click_searching_promotion';
                    break;
                case '/apply-card':
                    trackCategory = 'apply_card';
                    trackAction = 'click_apply_card';
                    break;
                case '/faq':
                    trackCategory = 'faq';
                    trackAction = 'click_faq';
                    break;
                case '/platinum-service':
                    trackCategory = 'platinum_service';
                    trackAction = 'click_platinum_service';
                    break;
                case 'privacy':
                    trackCategory = 'data_privacy';
                    trackAction = 'click_data_privacy';
                    break;
                case 'terms':
                    trackCategory = 'terms_conditions';
                    trackAction = 'click_terms_conditions';
                    break;
                case '/contact-us':
                    trackCategory = 'contact_us';
                    trackAction = 'click_contact_us';
                    break;
            }
            this.tracking.event(trackCategory, trackAction, null, null);
        },
    },
}
</script>
<style lang="scss" scoped>
@import "@/style/base/base.scss";
@import "@/style/modal.scss";
.sidebar-open {
    width: 280px;
    z-index: $zindex-modal;
}
.sidebar-close {
    width: 280px;
}
.sidemenu-bg {
    background-image: linear-gradient(to right, #1c2c73 0%, #016cb8 100%);
    border-top-right-radius: 20px;
    border-bottom-right-radius: 20px;
}
.img-wrap {
    width: 45px;
    height: 45px;
}
.ic-close {
    top: 25px;
    right: 20px;
}

.profileName {
    word-break: break-word;
}
</style>
